import { firestoreAction } from "vuexfire";

export default {
  // firestoreのデータをstoreで扱いたい場合、collection/documentのbindをここに書く
  setAdminRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("administrators", ref);
  }),
  // 拡張配分比率をstate(ticketMasterAllocationRatio)にバインドする
  setAllocationRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("ticketMasterAllocationRatios", ref);
  }),
  setAttributeMasterRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("attributeMaster", ref);
  }),
  setAttributeUsersRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("attributeUsers", ref);
  }),
  setCategoryRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("categoryMaster", ref);
  }),
  setCodeRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("codeMaster", ref);
  }),
  setCompanyRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("companyMaster", ref);
  }),
  setExternalLinkRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("externalLinkMaster", ref);
  }),
  setExternalLowerLinkRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("externalLowerLinkMaster", ref);
  }),
  setFacilitiesRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("facilityMaster", ref);
  }),
  setGateRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("gateMaster", ref);
  }),
  setGrantAttributeHistoryRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("grantAttributeHistory", ref);
  }),
  setGroupRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("groupMaster", ref);
  }),
  setHolidayRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("holidayMaster", ref);
  }),
  setMembersRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("members", ref);
  }),
  setOptionsRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("optionMaster", ref);
  }),
  setPriceRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("priceMaster", ref);
  }),
  setRouteSearchFilterRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("routeSearchFilterMaster", ref);
  }),
  setRouteSearchKeywordRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("routeSearchKeywordMaster", ref);
  }),
  setSalesRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("sales", ref);
  }),
  setSentMailHistoryRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("sentMailHistory", ref);
  }),
  setStationListMasterRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("stationListMaster", ref);
  }),
  setEnvironmentRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("environment", ref);
  }),
  setManagementRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("management", ref);
  }),
  setPropertiesRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("properties", ref);
  }),
  setRouteSearchRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("routeSearch", ref);
  }),
  setTicketDisplayLimitMasterRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("ticketDisplayLimitMaster", ref);
  }),
  setTicketDistributionRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("ticketDistribution", ref);
  }),
  setTicketRef: firestoreAction((context, ref) => {
    return context.bindFirestoreRef("ticketMaster", ref);
  }),
};
